export var useNormalizedTransition = function (callback, nodeRef) {
    return (function (maybeIsAppearing) {
        if (callback) {
            var node = nodeRef.current;
            // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
            if (maybeIsAppearing === undefined) {
                callback(node);
            }
            else {
                callback(node, maybeIsAppearing);
            }
        }
    });
};
export var useNormalizedTransitionProps = function (_a, nodeRef) {
    var onEnter = _a.onEnter, onEntering = _a.onEntering, onEntered = _a.onEntered, onExit = _a.onExit, onExiting = _a.onExiting, onExited = _a.onExited;
    var handleEnter = useNormalizedTransition(onEnter, nodeRef);
    var handleEntering = useNormalizedTransition(onEntering, nodeRef);
    var handleEntered = useNormalizedTransition(onEntered, nodeRef);
    var handleExit = useNormalizedTransition(onExit, nodeRef);
    var handleExiting = useNormalizedTransition(onExiting, nodeRef);
    var handleExited = useNormalizedTransition(onExited, nodeRef);
    return {
        onEnter: handleEnter,
        onEntering: handleEntering,
        onEntered: handleEntered,
        onExit: handleExit,
        onExiting: handleExiting,
        onExited: handleExited,
    };
};
